import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { WaitTipsScreen } from './WaitTipsScreen';
import type { WaitTipsSearch } from './wait-tips-search';

const route = getRouteApi('/wait-tips');

export function WaitTipsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const onSearchChange = useCallback(
    (next: WaitTipsSearch) => {
      void navigate({ replace: true, search: () => next });
    },
    [navigate],
  );
  return <WaitTipsScreen search={search} onSearchChange={onSearchChange} />;
}
